import {
  ButtonPrimary,
  ButtonSecondary,
  SidePanel,
  SidePanelType,
  DateInput,
  Table,
} from '@ui/src';
import { useAppSelector } from '@store';
import useAddTransactionsSidepanel from '../hooks/use-add-transactions-sidepanel';
import { AddTransactionsSidepanelTypes } from '../types';
import { columns, columnsLabels } from '../variables/incoming-transactions';

import cn from '../styles.module.css';

const AddTransactionsSidepanel = ({
  setAddTransactionsSidepanelVisible,
  addTransactionsSidepanelVisible,
  selectedReportTransferDate,
  setSelectedReportTransferDate,
  type,
  selectedReportId,
}: AddTransactionsSidepanelTypes) => {
  const {
    paymentTypes,
    incomingTransactions,
    incomingTransactionsPagination,
    errorsList,
  } = useAppSelector((state) => state.fintrac.list);
  const { currenciesList: currencies, currencies: currenciesList } =
    useAppSelector((state) => state.root);

  const {
    formattedData,
    onSort,
    filters,
    filtersComponent,
    sort,
    handleSubmit,
    isLoading,
    isFetching,
    errorList,
    onClear,
    onRowsSelect,
    handleClose,
    selectedTransactionsIds,
    onTableSetPage,
    onTableFilter,
    globalError,
    requestInProgress,
    onSubmit,
  } = useAddTransactionsSidepanel({
    transactions: incomingTransactions,
    setAddTransactionsSidepanelVisible,
    selectedReportTransferDate,
    setSelectedReportTransferDate,
    paymentTypes,
    currencies,
    currenciesList,
    addTransactionsSidepanelVisible,
    type,
    selectedReportId,
  });

  return (
    <SidePanel
      isOpen={addTransactionsSidepanelVisible}
      title="Add transaction to report"
      sidepanelExpandedKey="add-fintrac-transcations-panel"
      onClose={handleClose}
      type={SidePanelType.Accounts}
      errorSidepanel={globalError}
      footer={
        <>
          <ButtonPrimary
            text={requestInProgress ? 'Loading...' : 'Save report'}
            onClick={onSubmit}
            disabled={!selectedTransactionsIds?.length || requestInProgress}
            bold
          />
          <ButtonSecondary
            text="Close"
            onClick={handleClose}
            className="button-white"
            bold
          />
        </>
      }
      closeOnClickOutside
      expanded
    >
      <div className={cn.addTransactionsWrapper}>
        <div className={cn.addTransactionsTop}>
          <div className={cn.transferDateWrapper}>
            <DateInput
              title="Transfer Date"
              placeholder="Select date"
              value={selectedReportTransferDate}
              disabled
            />
          </div>
        </div>
        <div className={cn.addTransactionsTable}>
          <Table
            title="Incoming transactions"
            columns={columns}
            data={formattedData || []}
            onSort={(name) => {
              onSort(name);
            }}
            filters={filters}
            filtersComponent={filtersComponent}
            sort={sort}
            columnsLabels={columnsLabels}
            selectedIds={selectedTransactionsIds}
            onFilterChange={(values) => onTableFilter(values)}
            handleSubmit={handleSubmit}
            isLoading={
              isLoading || isFetching || incomingTransactions === undefined
            }
            take="30"
            setPage={(data) => onTableSetPage(data)}
            pagination={incomingTransactionsPagination}
            error={errorsList || errorList}
            paginationDisabled={isFetching}
            onClearAutoComplete={() => onClear()}
            isFetching={isFetching}
            onRowsSelect={onRowsSelect}
            tableName="add-transactions-table"
            clickable
            newWindow
            withToggleInput
            withVerticalScroll
            withScroll
            transactionTable
            withDeleteIcon
          />
        </div>
      </div>
    </SidePanel>
  );
};

export default AddTransactionsSidepanel;
